<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="Pending Asset Register"
            />
        </div>

        <div class="px-2">
           <div class="row">
             <div class="col-12 col-sm-6 col-md-4 col-lg-3">
               <div class="d-flex align-items-center justify-content-between">
                 <label for="colFormLabel" class="col-form-label">Group: </label>
               </div>

               <AsyncSelect
                   placeholder="Select Group"
                   v-model="selectGroup"
                   :api-service="fetchProductList"
                   :format-label="option => option.text"
                   label="text"
                   :additional-query="{ product_type: 'fixed_assets', group_level:1 }"
               />
             </div>

             <div class="col-12 col-sm-6 col-md-4 col-lg-3">
               <div class="d-flex align-items-center justify-content-between">
                 <label for="colFormLabel" class="col-form-label">Class Name: </label>
               </div>

               <AsyncSelect
                   placeholder="Select Class Name"
                   v-model="selectedProduct"
                   :api-service="fetchProductList"
                   :format-label="option => option.text"
                   label="text"
                   :additional-query="{ product_type: 'fixed_assets' }"
               />
             </div>

             <div class="col-12 col-sm-6 col-md-4 col-lg-3">
               <div class="d-flex align-items-center justify-content-between filter-label">
                 <label for="colFormLabel" class="col-form-label">Supplier: </label>
                 <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
               </div>

               <AsyncSelect
                   placeholder="Select Supplier"
                   v-model="contactProfile"
                   :api-service="fetchContactProfiles"
               />
             </div>

             <div class="col-12 col-sm-6 col-md-4 col-lg-2">
               <div class="d-flex align-items-center justify-content-between filter-label">
                 <label for="colFormLabel" class="col-form-label">Bill Number: </label>
               </div>

               <input
                   placeholder="Bill Number"
                   v-model="billNumber"
                   class="form-control"
               />
             </div>

             <div class="col-sm-2 col-md-2 col-lg-1 d-flex align-items-end mt-2 action-btn-setter">
               <button
                   style="min-width: 64px;"
                   @click="getPendingAssetRegisterList"
                   class="btn btn-primary btn-block waves-effect waves-float waves-light"
               > Go
               </button>
             </div>
           </div>
        </div>
        <div class="col-12 px-2 mt-1">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Fixed Asset Category</th>
                  <th>Asset Class</th>
                  <th>Stock Register Reference</th>
                  <th>Bill Date</th>
                  <th>Supplier</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in stockRegisterList" :key="i">
                  <td>{{ item.asset_category }}</td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.voucher_number }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.contact_profile_name }}</td>
                  <td>
                    <button class="btn btn-primary btn-sm"
                            @click="goToAdd(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="!stockRegisterList.length" class="text-center mt-5">No data</p>
            </div>
          </div>

          <div class="px-2">
            <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
          </div>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            type="customer"
        />
        <GlobalLoader />
    </div>
    </div>
</template>

<script setup>
import { ref, inject, reactive, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handleAssetRegister from '@/services/modules/assetRegister/assetRegister'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handlePurchaseAndSales from "@/services/modules/purchase";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let stockRegisterList = ref([])
const route = useRoute()
let contactProfile = ref(null)
let billNumber = ref(null)
const selectedProduct = ref(null);
const selectGroup = ref(null);

const { fetchPendingAssetRegister } = handleAssetRegister()
const { fetchContactProfiles } = handleContact();
const { fetchProductList } = handlePurchaseAndSales()

const companyId = computed(() => {
    return route.params.companyId
})

function getQuery () {
  let queryStr = '?company_id=' + route.params.companyId
  queryStr += '&offset=' + offset.value
  if (route.query.page) queryStr += "&page=" + route.query.page;
  if(contactProfile.value) queryStr += '&contact_profile_id=' + contactProfile.value.id;
  if(selectedProduct.value) queryStr += '&product_id=' + selectedProduct.value.id;
  if(selectGroup.value) queryStr += '&group_id=' + selectGroup.value.id;
  if(billNumber.value) queryStr += '&bill_number=' + billNumber.value;
  return queryStr
}

function getPendingAssetRegisterList() {
    const query = getQuery();
    const queryString = new URLSearchParams(query);

   fetchPendingAssetRegister("?" + queryString.toString())
    .then(res => {
        if (!res.status){
          stockRegisterList.value = []
          store.commit("resetPagination")
          return
        }
        stockRegisterList.value = res.data.data
        setPagination(res.data)
    })
}

function setPagination(data) {
    if(!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getPendingAssetRegisterList()
}

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true;
}

const goToAdd = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.stockRegisterId = item.id;

  router.push({
    name:  'asset-register-add',
    params: param,
    query: query
  })
}

const onSearchContact = (contact) => {
    contactProfile.value = contact
}

</script>
